class NewarrivalPopup extends HTMLElement {
    constructor() {
      super();
  
      //クッキーの名前の設定とdata-expire-hours があればそれを使い、なければ24を使う
      this.cookieName = 'newarrival_popup_v1';
      this.expireHours = parseInt(this.dataset.expireHours || 24, 10);
  
      // DOMの描画がされた直後のタイミングで初期化する
      window.requestAnimationFrame(() => {
        this.popup = this.querySelector('.newarrival-popup');
        this.closeBtn = this.querySelector('.newarrival-popup__close');
        this.link = this.querySelector('.newarrival-popup__link');
  
        // popupが無ければ何もせず終了（保険）
        if (!this.popup) return;
  
        this.bindEvents();
  
        if (this.shouldAutoOpen()) {
          this.open();
        }
      });
    }
  
    bindEvents() {
      // 閉じるボタンを押した時にクッキーに保存・閉じる処理をする
      this.closeBtn?.addEventListener('click', () => {
        this.saveCookie();
        this.close();
      });
  
      // 画像リンククリックしたときにクッキーに保存する
      this.link?.addEventListener('click', () => {
        this.saveCookie();
      });

      //背景クリックで非表示
      this.popup.addEventListener('click', (e) => {
        if (!e.target.closest('.newarrival-popup__content')) {
          this.saveCookie();
          this.close();
          }
      });
  
      // 左下アイコンをクリックしたときにクッキー無視して強制的に開く
      document.addEventListener('click', (e) => {
        if (e.target.closest('.js-newarrival-open')) {
          this.open(true);
        }
      });
    }
  
    //それぞれのメソッドの設定をする

    //自動で表示していいかどうか、前回のクッキーがない場合は無条件で表示。
    shouldAutoOpen() {
      const last = this.getCookie();
      if (!last) return true;
  
      //前回からどれくらい時間が経っているか
      const diff = Date.now() - Number(last);

      //24時間以上経っていたらtrue、それ以外はfalse
      return diff > this.expireHours * 60 * 60 * 1000;
    }
  
    //開く動作
    open(force = false) {
      if (!this.popup) return;
      //強制じゃない時かつ自動表示もない状態なら開かない
      if (!force && !this.shouldAutoOpen()) return;
  
      //そうでなければ開く
      this.popup.classList.add('is-active');
    }
  
    //閉じる動作
    close() {
        //ポップアップがない時は何もしない
      if (!this.popup) return;
      //is-activeを持っていたら取り除く
      this.popup.classList.remove('is-active');
    }
  
    //クッキーへの保存、呼ばれたらクッキーを書き込む
    saveCookie() {
        //クッキーの時間を秒に変換
      const expires = this.expireHours * 60 * 60;
      //今の時間をクッキーに書き込む、24時間経過後にクッキーは自動削除
      document.cookie = `${this.cookieName}=${Date.now()}; max-age=${expires}; path=/`;
    }
  
    //クッキーを取り出す

    getCookie() {
        //指定した名前のクッキーを正規表現で探す
      const match = document.cookie.match(
        new RegExp('(^| )' + this.cookieName + '=([^;]+)')
      );
      //配列がクッキーの値を返し、なければnullを返す
      return match ? match[2] : null;
    }
  }
  
  customElements.define('newarrival-popup', NewarrivalPopup);
